import api from "./api";

const settingsService = {
    // Restaurant
    getRestaurant: () => api.get("/settings/restaurant"),
    saveRestaurant: (data) => api.put("/settings/restaurant", data),

    // Front-desk discount rule (owner). Read back through getRestaurant.
    saveDiscounts: (data) => api.put("/settings/discounts", data),

    // Salon: printer or no printer, and the WhatsApp bill message (owner).
    saveWhatsApp: (data) => api.put("/settings/whatsapp", data),

    // POS: tap-to-add menu cards (hide + / stepper). Read back through getRestaurant.
    saveMenu: (data) => api.put("/settings/menu", data),

    // Payments
    getPayments: () => api.get("/settings/payments"),
    savePayments: (data) => api.put("/settings/payments", data),

    // Security
    getSecurity: () => api.get("/settings/security"),
    saveSecurity: (data) => api.put("/settings/security", data),

    // Order Number Format
    getOrderNumberFormat: () => api.get("/settings/order-number-format"),
    saveOrderNumberFormat: (data) => api.put("/settings/order-number-format", data),

    // Staff & Permissions
    getRoles: () => api.get("/settings/roles"),
    getPermissions: () => api.get("/settings/permissions"),
    getRolePermissions: (roleId) => api.get(`/settings/roles/${roleId}/permissions`),
    saveRolePermissions: (roleId, permissionIds) =>
        api.put(`/settings/roles/${roleId}/permissions`, { permission_ids: permissionIds }),

    // Password
    changePassword: (data) => api.put("/settings/change-password", data)
};

export default settingsService;
